import { Navigate, useLoaderData } from "react-router-dom";
import { LoaderData } from "../model";

export const Login = () => {
  const { authenticated } = useLoaderData() as LoaderData;
  return authenticated ? (
    <Navigate to="/sso/oidc/login_redirect" />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "var(--nj-semantic-color-background-neutral-primary-default)",
      }}
    >
      Redirection vers l’authentification
    </div>
  );
};
